import './assets/main.css'
import { createApp } from 'vue'
import { MotionPlugin } from '@vueuse/motion'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(router)
app.use(MotionPlugin)

// Mount app
app.mount('#app')

// Initialize performance monitoring in development
if (import.meta.env.DEV) {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(async () => {
      const { initPerformanceMonitoring } = await import('./performance.js')
      initPerformanceMonitoring()
    })
  } else {
    setTimeout(async () => {
      const { initPerformanceMonitoring } = await import('./performance.js')
      initPerformanceMonitoring()
    }, 1000)
  }
}


// Initialize performance monitoring in development after the page is idle
if (import.meta.env.DEV) {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(async () => {
      const { initPerformanceMonitoring } = await import('./performance.js')
      initPerformanceMonitoring()
    })
  } else {
    setTimeout(async () => {
      const { initPerformanceMonitoring } = await import('./performance.js')
      initPerformanceMonitoring()
    }, 1000)
  }
}
